import { ChevronDown, ChevronUp } from 'lucide-react'
import { SparkleLoader } from '../../../../common/SparkleLoader'
import {
  FooterHeader,
  HeaderFlexContainer,
  ScoreLabel,
  ScoreValue,
  ActionGroup,
} from '../styles/StakeholderRatingsFooterStyles'
import type { CategoryStyle } from '../types'

interface AccordionHeaderProps {
  ratingLabel: string
  averageRating: number | null
  isExpanded: boolean
  isGenerating: boolean
  categoryStyle: CategoryStyle
  onToggle: () => void
}

/**
 * Clickable header showing the average rating score with expand/collapse toggle
 */
export function AccordionHeader({
  ratingLabel,
  averageRating,
  isExpanded,
  isGenerating,
  categoryStyle,
  onToggle,
}: AccordionHeaderProps): React.JSX.Element {
  return (
    <FooterHeader $clickable={true} onClick={onToggle}>
      <HeaderFlexContainer>
        <ScoreLabel>{ratingLabel}</ScoreLabel>
        <ActionGroup>
          <ScoreValue $accentColor={categoryStyle.accentColor}>
            {averageRating ?? '-'}/10
          </ScoreValue>
          {isExpanded ? (
            <ChevronUp size={12} color={categoryStyle.iconColor} />
          ) : (
            <ChevronDown size={12} color={categoryStyle.iconColor} />
          )}
          {isGenerating && <SparkleLoader isAnimating={true} size={20} />}
        </ActionGroup>
      </HeaderFlexContainer>
    </FooterHeader>
  )
}
